import { connect } from "react-redux";
import PlanHeader from "./Component";

const mapStateToProps = ({ planv2: { planv2 } }) => ({ planv2 });

export default connect(mapStateToProps)(PlanHeader);
